import {
    CREATE_TOAST,
    REMOVE_TOAST,
    RESET_TOASTS
} from "actions/index"

import _clone from "lodash/clone"
import _remove from "lodash/remove"
import _takeRight from "lodash/takeRight"
import { Action } from "app/types/app-types"
import { Toast } from "app/helpers/toast_factory"

export type Toasts = Array<Toast>

/**
 * Toasts Reducer.
 *
 * @param state
 * @param action
 */
export default function (state: Toasts = [], action: Action<any>) {
    switch (action.type) {
        case CREATE_TOAST:
            let clonedState = _clone(state);
            clonedState.push(action.payload)
            return _takeRight(clonedState, 3);
        case REMOVE_TOAST:
            return _remove(state, (toast) => {
                return toast.id !== action.payload
            });
        case RESET_TOASTS:
            return []
        default:
            return state
    }
}
